import React, { useState } from "react";
import { colors, Grid, Hidden, Typography } from "@material-ui/core";
import Barcode from "react-barcode/lib/react-barcode";
import { sto } from "../../../../../Context/InshData";

function BarcodeAndPrice(props) {
    const { barcode, itemName, price, maqas, permiCuCo, tax } = props;
    let Item_Price = price;
    if (permiCuCo == 0 && tax != 0) {
        Item_Price = (price + (price * tax) / 100).toFixed(2);
    }else{
         Item_Price = price;   
    }
  
    const width = 2;
    const hight = 30;

    return (
        <div justifyContent="center" style={{
            minWidth: `${maqas.wisthPaper}mm`,
            maxWidth: `${maqas.wisthPaper}mm`,
            minHeight: '20mm',
            textAlign: "center",
            backgroundColor: "#fff",
            paddingTop: `${maqas?.margnTop}mm`,
            paddingBottom: `${maqas?.margnBottom}mm`,
        }}>
            <div
                style={{
                    minWidth: '50mm',
                    paddingRight: '1mm',
                    paddingLeft: '1mm',
                    padding: '1mm',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    fontSize: '12px',
                    // textAlign:'center',
                    backgroundColor: '#fff',

                }}
            >
                <Barcode value={barcode} width={width} height={hight} />

            </div>
            <div style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1 }}>{Item_Price}{""}{"رس  "}</div>
        </div>
    );
}

export default BarcodeAndPrice;
